export default () => {
    $('#new-form').on('submit', function(e){
        e.preventDefault();
        var name = $("#name").val();
        $.ajax({
            type: "post",
            url: myAjax.ajaxurl,
            data: {action: "get-data-new", page_name: name},
            success: function (response) {
              $('.block-new-list').html(response);
            },
            complete: function () {
              //$('.data-check').hide();
            }
          });
    
    });
   
}
    